import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import MdExpandMore from 'react-icons/lib/md/expand-more'

const styles = (theme) => ({
  expansionPanel: {
    boxShadow: 'none',
    border: `1px solid ${theme.palette.borders.cloudier}`,
  },
  expansionPanelSummary: {
    background: theme.palette.primary.main,
  },
  expansionPanelSummaryHeading: {
    flexBasis: '40%',
    flexShrink: 0,
    color: '#fff',
  },
  mentions: {
    minHeight: 40,
    padding: '2px 0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
  mentionCounterOuter: {
    display: 'inline-block',
    borderRadius: '50%',
    background: theme.palette.primary.main,
    color: '#fff',
    fontWeight: 500,
  },
  mentionCounterInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 35,
    height: 35,
  },
})

class Mentions extends React.Component {
  state = { expanded: false }

  componentDidMount = () => {
    const { mentions } = this.props
    if (Array.isArray(mentions)) {
      if (mentions.length > 0) {
        return this.setState({ expanded: true })
      }
    }
  }

  openPanel = () => this.setState({ expanded: !this.state.expanded })

  renderMentions = () => {
    const { classes, mentions } = this.props
    if (!mentions) {
      return (
        <Typography className={classes.mentions}>No mentions yet</Typography>
      )
    }
    return mentions.map((mention, i) => (
      <Typography
        component="div"
        key={mention}
        target="_blank"
        className={classes.mentions}
      >
        <div className={classes.mentionCounterOuter}>
          <div className={classes.mentionCounterInner}>{i + 1}</div>{' '}
        </div>
        <a href={mention} target="_blank" style={{ paddingLeft: 10 }}>
          {mention}
        </a>
      </Typography>
    ))
  }

  render() {
    const { state } = this
    const { classes, mentions } = this.props

    const timesMentioned = Array.isArray(mentions) ? mentions.length : 0

    return (
      <ExpansionPanel
        classes={{ root: classes.expansionPanel }}
        expanded={state.expanded}
        onChange={this.openPanel}
      >
        <ExpansionPanelSummary
          classes={{ root: classes.expansionPanelSummary }}
          expandIcon={<MdExpandMore style={{ color: '#ecf4f2' }} />}
        >
          <Typography className={classes.expansionPanelSummaryHeading}>
            Mentioned{' '}
            <span style={{ fontWeight: 500, color: '#4fecfb' }}>
              {timesMentioned}
            </span>{' '}
            times
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>{this.renderMentions()}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }
}

Mentions.propTypes = {
  classes: PropTypes.object.isRequired,
  mentions: PropTypes.arrayOf(PropTypes.string),
}

export default withStyles(styles)(Mentions)



// WEBPACK FOOTER //
// ./src/components/Mentions.js